    <div class="low-navbar-account">
        <ul>
            @for(item of navItems; track item.item){
                <li [ngClass]="{'nav-item-active' : item.active, 'nav-item': !item.active}">
                    <a (click)="triggerAction(item.item)">{{ item.name }}</a>
                </li>
            }
        </ul>
        <hr>
    </div>
    <app-activities *ngIf="navItems[0].active"></app-activities>
    <app-com-manage *ngIf="navItems[2].active" [account]="account"></app-com-manage>
    <app-cont-camp *ngIf="navItems[3].active"></app-cont-camp>